export const PERMISSIONS = {
  ATTENDANCE_VIEW: 'ATTENDANCE_VIEW',
  ATTENDANCE_MARK: 'ATTENDANCE_MARK',
  ATTENDANCE_CORRECT: 'ATTENDANCE_CORRECT',
  ATTENDANCE_APPROVE: 'ATTENDANCE_APPROVE',
  EMPLOYEE_VIEW: 'EMPLOYEE_VIEW',
  EMPLOYEE_CREATE: 'EMPLOYEE_CREATE',
  EMPLOYEE_UPDATE: 'EMPLOYEE_UPDATE',
  EMPLOYEE_DELETE: 'EMPLOYEE_DELETE',
  FACE_REGISTER: 'FACE_REGISTER',
  FACE_VERIFY: 'FACE_VERIFY',
  LEAVE_APPLY: 'LEAVE_APPLY',
  LEAVE_APPROVE: 'LEAVE_APPROVE',
  // Installed DB codes for employee time-permission requests.
  PERMISSION_APPLY: 'PERMISSION_APPLY',
  PERMISSION_APPROVE: 'PERMISSION_APPROVE',
  /** View history/details — installed code is PERMISSION_APPLY (no separate VIEW). */
  TIME_PERMISSION_VIEW: 'PERMISSION_APPLY',
  /** Apply requests — same installed code; Apply route is not mounted yet. */
  TIME_PERMISSION_APPLY: 'PERMISSION_APPLY',
  /** Cancel requests — same installed code; Cancel route is not mounted yet. */
  TIME_PERMISSION_CANCEL: 'PERMISSION_APPLY',
  REPORT_VIEW: 'REPORT_VIEW',
  REPORT_EXPORT: 'REPORT_EXPORT',
  WFH_APPLY: 'WFH_APPLY',
  WFH_APPROVE: 'WFH_APPROVE',
  PROJECT_VIEW: 'PROJECT_VIEW',
  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_UPDATE: 'PROJECT_UPDATE',
  /** Granted to HR_ADMIN, TEAM_LEAD and REPORTING_MANAGER by the visitor SQL script. */
  VISITOR_VIEW: 'VISITOR_VIEW',
  VISITOR_MANAGE: 'VISITOR_MANAGE',
  /**
   * Organization master-data uses SETTINGS_* only.
   * There are no ORGANIZATION_*, LOCATION_*, DEPARTMENT_*, DESIGNATION_*,
   * or TEAM_* permission codes in the installed database.
   */
  SETTINGS_VIEW: 'SETTINGS_VIEW',
  SETTINGS_UPDATE: 'SETTINGS_UPDATE',
  ORGANIZATION_VIEW: 'SETTINGS_VIEW',
  ORGANIZATION_UPDATE: 'SETTINGS_UPDATE',
  LOCATION_VIEW: 'SETTINGS_VIEW',
  LOCATION_CREATE: 'SETTINGS_UPDATE',
  LOCATION_UPDATE: 'SETTINGS_UPDATE',
  DEPARTMENT_VIEW: 'SETTINGS_VIEW',
  DEPARTMENT_CREATE: 'SETTINGS_UPDATE',
  DEPARTMENT_UPDATE: 'SETTINGS_UPDATE',
  DESIGNATION_VIEW: 'SETTINGS_VIEW',
  DESIGNATION_CREATE: 'SETTINGS_UPDATE',
  DESIGNATION_UPDATE: 'SETTINGS_UPDATE',
  TEAM_VIEW: 'SETTINGS_VIEW',
  TEAM_CREATE: 'SETTINGS_UPDATE',
  TEAM_UPDATE: 'SETTINGS_UPDATE',
  /**
   * Shift / work-policy master-data uses SETTINGS_* only.
   * There are no SHIFT_* or WORK_POLICY_* permission codes in the
   * installed database. Swagger labels map to these codes.
   */
  SHIFT_VIEW: 'SETTINGS_VIEW',
  SHIFT_CREATE: 'SETTINGS_UPDATE',
  SHIFT_UPDATE: 'SETTINGS_UPDATE',
  WORK_POLICY_VIEW: 'SETTINGS_VIEW',
  WORK_POLICY_CREATE: 'SETTINGS_UPDATE',
  WORK_POLICY_UPDATE: 'SETTINGS_UPDATE',
  CALENDAR_VIEW: 'SETTINGS_VIEW',
  CALENDAR_MANAGE: 'SETTINGS_UPDATE',
} as const;

/**
 * Leave self-service screens (history/filters/summary details).
 * Apply/cancel remain capability-gated until those routes are mounted.
 */
export const LEAVE_ACCESS_PERMISSIONS = [PERMISSIONS.LEAVE_APPLY] as const;

/**
 * Workflow routes accept any installed approval permission.
 * There is no separate WORKFLOW_VIEW / WORKFLOW_APPROVE database code.
 */
export const WORKFLOW_INBOX_PERMISSIONS = [
  PERMISSIONS.ATTENDANCE_APPROVE,
  PERMISSIONS.LEAVE_APPROVE,
  PERMISSIONS.WFH_APPROVE,
  PERMISSIONS.PERMISSION_APPROVE,
] as const;
